import { FieldSchema } from '@lsq-frontend/remote-services/ar-app';

export class AbstractField {
    constructor() {}

    public addRequiredAsterisk(fieldSchema: FieldSchema): string {
        if (fieldSchema.isRequired) {
            return fieldSchema.label + '*';
        }
        return fieldSchema.label;
    }
}
